import { render, staticRenderFns } from "./pickups.vue?vue&type=template&id=653d4a64&scoped=true&"
import script from "./pickups.vue?vue&type=script&lang=js&"
export * from "./pickups.vue?vue&type=script&lang=js&"
import style0 from "./pickups.vue?vue&type=style&index=0&id=653d4a64&scoped=true&lang=css&"
import style1 from "./pickups.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d4a64",
  null
  
)

export default component.exports